import React from 'react';
import SwipeableViews from 'react-swipeable-views';

import Tabs from '@material-ui/core/Tabs';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          {children}
        </Box>
      )}
    </div>
  );
}

const StyledTabs = withStyles((theme) => ({
  root: {
    flex: 1,
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: 'transparent !important',
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
  },
}))(Tabs);

const StyledTab = withStyles((theme) => ({
  root: {
    backgroundColor: 'transparent !important',
    textTransform: 'none',
    textAlign: 'left',
    minWidth: 72,
    fontWeight: 600,
    fontSize: (props) => props.fontSize || 12,
    marginRight: theme.spacing(4),
    paddingLeft: 0,
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.text.primary,
      opacity: 1,
    },
    '&$selected': {
      color: theme.palette.text.primary,
      fontWeight: 600,
    },
    '&:focus': {
      color: theme.palette.text.primary,
    },
  },
  selected: {
    color: theme.palette.text.primary,
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tabsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  padding: {
    padding: theme.spacing(3),
  },
}));

export default function CustomizedTabs({ tabs, activeTab, onTabChange, fontSize, children, renderActions }) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div className={classes.root}>
      <div className={classes.tabsContainer}>
        <StyledTabs
          value={activeTab}
          onChange={(e, value) => onTabChange(value)}
          aria-label="ant example"
        >
          {tabs.map((tab, index) => (
            <StyledTab
              key={index}
              label={typeof tab === 'object' ? tab.label : tab}
              onChange={(e, value) => onTabChange(value)}
              disabled={tab.disabled}
              icon={tab.icon}
              fontSize={fontSize}
            />
          ))}
        </StyledTabs>
        {!!renderActions && (
          <div className='m-l-md'>
            {renderActions()}
          </div>
        )}
      </div>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeTab}
        onChangeIndex={onTabChange}
      >
        {tabs.map((tab, index) => (
          <TabPanel
            key={`tab-${index}`}
            value={activeTab}
            index={index}
            dir={theme.direction}
          >
            {children}
          </TabPanel>
        ))}
      </SwipeableViews>
    </div>
  );
}
